import React, { useState } from 'react';
import { FiChevronDown } from 'react-icons/fi';
import './FAQ.css';

const faqData = [
  {
    question: "How long does collision repair take?",
    answer: "Repair timelines vary depending on the extent of damage. Minor dent repairs may take 1-2 days, while major collision repairs can take 1-3 weeks. We provide a detailed timeline with every estimate and keep you updated throughout the process."
  },
  {
    question: "Does insurance cover auto body repair?",
    answer: "Yes, most auto insurance policies cover collision repair. We work directly with all major insurance companies including State Farm, GEICO, Progressive, Allstate, USAA, and more. We handle all the paperwork and communicate directly with your adjuster."
  },
  {
    question: "Do you offer free estimates?",
    answer: "Yes! We provide free, no-obligation estimates for all repair work. You can walk in during business hours or call (832) 615-6065 to schedule an appointment."
  },
  {
    question: "What areas do you serve?",
    answer: "We serve Spring, Klein, The Woodlands, Tomball, Humble, Cypress, and the greater North Houston area. We also offer towing services to our facility."
  },
  {
    question: "Do you have a lifetime warranty?",
    answer: "Yes, we provide a lifetime warranty on all body work and collision repairs performed at our shop. We stand behind every repair we complete."
  },
  {
    question: "Do you work with all insurance companies?",
    answer: "Yes, we work with all insurance providers. You have the legal right to choose any repair shop regardless of what your insurance company suggests. We handle all claims paperwork directly."
  },
  {
    question: "Can I get a rental car while my vehicle is being repaired?",
    answer: "We can help coordinate rental car arrangements through your insurance company. Most collision coverage includes rental car benefits during the repair period."
  },
  {
    question: "What should I do after a car accident?",
    answer: "First, ensure everyone is safe and call 911 if needed. Exchange information with the other driver, take photos of the damage, and file a police report. Then call Axis Collision Center at (832) 615-6065 — we'll guide you through the rest of the process including insurance claims and towing."
  }
];

const FAQItem = ({ question, answer, isOpen, onClick }) => (
  <div className={`faq__item ${isOpen ? 'faq__item--open' : ''}`}>
    <button className="faq__question" onClick={onClick} aria-expanded={isOpen}>
      <span>{question}</span>
      <FiChevronDown className={`faq__icon ${isOpen ? 'faq__icon--rotated' : ''}`} />
    </button>
    <div className={`faq__answer ${isOpen ? 'faq__answer--visible' : ''}`}>
      <p>{answer}</p>
    </div>
  </div>
);

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq section">
      <div className="container">
        <div className="faq__header">
          <h2 className="faq__title">Frequently Asked Questions</h2>
          <p className="faq__subtitle">
            Get answers to common questions about collision repair and our services
          </p>
        </div>
        <div className="faq__list">
          {faqData.map((item, index) => (
            <FAQItem
              key={index}
              question={item.question}
              answer={item.answer}
              isOpen={openIndex === index}
              onClick={() => toggleFAQ(index)}
            />
          ))}
        </div>
        <div className="faq__cta">
          <p>Have more questions? We're here to help.</p>
          <a href="tel:+18326156065" className="btn btn--primary">
            Call (832) 615-6065
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
